import React from "react";


export default function Content(props){
  return(
  <>
      <h1 className="page_heading">{props.name}</h1>
  </>
    )
}